import { baseClasses } from '@weatherbug/common';
import cloneDeep from 'lodash.clonedeep';
import { createFavoriteLocation } from './favoriteLocationActions';
import { DraggableLocationItem, FavoriteLocation, Locality, LocationItemDetails, Station, Location, GetAllStationsParams } from '../../components/locationManagerPopup/locationManagerPopupTypes';
import { ManageLocationsPopupProvider } from '../providers/manageLocationsPopupProvider';
import ngDeps from '../utilities/ngDependencies';

export const SET_POPUP_LOCATIONS = 'SET_POPUP_LOCATIONS';
export const REORDER_USER_MANAGED_LOCATIONS = 'REORDER_USER_MANAGED_LOCATIONS';
export const SHOW_MANAGED_LOCATIONS_POPUP = 'SHOW_MANAGED_LOCATIONS_POPUP';
export const CLEAR_SAVED_FAVORITE_LOCATION_FOR_UNDO  = 'CLEAR_SAVED_FAVORITE_LOCATION_FOR_UNDO';
export const SAVE_POPUP_LOCATION_DATA_BEFORE_DELETE  = 'SAVE_POPUP_LOCATION_DATA_BEFORE_DELETE';
export const TOGGLE_STATION_CHANGER = 'TOGGLE_STATION_CHANGER';
export const MAP_STATION_FEATURE_HOVER_ACTION = 'MAP_STATION_FEATURE_HOVER_ACTION';
export const STATION_CHANGER_LIST_ITEM_IS_HOVERED = 'STATION_CHANGER_LIST_ITEM_IS_HOVERED';
export const STATION_LIST_IS_HOVERED = 'STATION_LIST_IS_HOVERED';
export const MAP_ICON_HOVERED = 'MAP_ICON_HOVERED';
export const RESET_STATION_CHANGER_DATA = 'RESET_STATION_CHANGER_DATA';
export const IS_INITIAL_STATIONS_CHANGER_LOAD = 'IS_INITIAL_STATIONS_CHANGER_LOAD';

const { AsyncAction } = baseClasses;

export const QUERY_LOCATION_BY_SLUG_NAME = new AsyncAction('QUERY_LOCATION_BY_SLUG_NAME');

export interface ManageLocationsPopupUndoData {
    deletedFavoriteLocation?: FavoriteLocation;
    favoriteLocationsListBeforeDelete?: FavoriteLocation[];
    showUndoButton: boolean;
}
export interface MapFeatureActionPayload {
    hoveredItemStationId: string;
    mapFeatureId: number;
    isMouseOverItem: boolean;
}

export const GET_STATIONS_BY_LAT_LNG = new AsyncAction('GET_STATIONS_BY_LAT_LNG');

export type ToggleStationChangerType = {
    type: typeof TOGGLE_STATION_CHANGER;
    payload: LocationItemDetails;
}


export type StationChangerListActionType = {
    type: typeof STATION_LIST_IS_HOVERED;
    payload: boolean;
}

export type StationChangerListItemActionType = {
    type: typeof STATION_CHANGER_LIST_ITEM_IS_HOVERED;
    payload: {
        isListItemsHovered: boolean;
        hoveredListItemStationId: string;
    };
}
export interface  DisplayAllStationForLocation extends LocationItemDetails {
    stationsList?: Station[];
}

export type GetStationsByLatLngType = {
    type: typeof GET_STATIONS_BY_LAT_LNG.base;
    payload: Station[] | any;
}

export type UserReOrderLocationType = {
    type: typeof REORDER_USER_MANAGED_LOCATIONS;
    payload: DraggableLocationItem;
}

export type LocationsManagerPopupLocationsType = {
    type: typeof SET_POPUP_LOCATIONS;
    payload: FavoriteLocation[];
}

export type ShowManagedLocationsPopupType = {
    type: typeof SHOW_MANAGED_LOCATIONS_POPUP;
    payload: boolean;
}

export type ClearSavedDataForUndoType = {
    type: typeof CLEAR_SAVED_FAVORITE_LOCATION_FOR_UNDO;
    payload: ManageLocationsPopupUndoData;
}

export type SavePopupLocationDataBeforeDeleteType = {
    type: typeof SAVE_POPUP_LOCATION_DATA_BEFORE_DELETE;
    payload: ManageLocationsPopupUndoData;
}

export type QueryLocationBySlugNameType = {
    type: typeof QUERY_LOCATION_BY_SLUG_NAME;
    payload: Promise<any>;
}

export type LocationStationMapFeatureHoverActionType = {
    type: typeof MAP_STATION_FEATURE_HOVER_ACTION;
    payload: MapFeatureActionPayload;
}

interface MapIconMouseActionPayload {
    isMouseOverMapIcon: boolean;
    stationId?: string;
}

export type OnMouseEnterOrLeaveMapIconType = {
    type: typeof MAP_ICON_HOVERED;
    payload: MapFeatureActionPayload;
}

export type ResetStationChangerDataActionType = {
    type: typeof RESET_STATION_CHANGER_DATA
}

export type IsInitialStationsChangerLoadActionType = {
    type: typeof IS_INITIAL_STATIONS_CHANGER_LOAD;
    payload: boolean;
}

// TODO: hook this up in next PR to current conditions arrow button that lunches manage loc popup
export function showManagedLocationsPopup(showManagedLocationsPopup: boolean): ShowManagedLocationsPopupType {
    return {
        type: SHOW_MANAGED_LOCATIONS_POPUP,
        payload: showManagedLocationsPopup
    };
}

// TODO: see if this is required when rewrite of the manage locations is complete - probably not
export function setupLocationsForPopup(locations: FavoriteLocation[]): LocationsManagerPopupLocationsType {
    return {
        type: SET_POPUP_LOCATIONS,
        payload: locations
    };
}

export function clearSavedFavoriteLocationDataForUndo(): ClearSavedDataForUndoType {
    const clearSavedDataForUndo: ManageLocationsPopupUndoData = {
        favoriteLocationsListBeforeDelete: [],
        deletedFavoriteLocation: undefined,
        showUndoButton: false
    };
    return {
        type: CLEAR_SAVED_FAVORITE_LOCATION_FOR_UNDO,
        payload: clearSavedDataForUndo
    };
}

export function undoDeletedFavoriteLocation(): void {
    return async (dispatch, getState) => {
        const currState = getState();
        const savedLocationListBeforeDelete: FavoriteLocation[] = currState?.manageLocationsPopup?.undoData?.favoriteLocationsListBeforeDelete;
        const favoriteLocationToUndoDelete: FavoriteLocation = currState?.manageLocationsPopup?.undoData?.deletedFavoriteLocation;
        const locationItemStationChangerData: LocationItemDetails = currState?.manageLocationsPopup?.toggleStationChanger?.displayedStationsLocationData;

        try {
            if (favoriteLocationToUndoDelete) {
                await dispatch(createFavoriteLocation(favoriteLocationToUndoDelete));
            }

            let locationsList: FavoriteLocation[];
            if (favoriteLocationToUndoDelete) {
                if (savedLocationListBeforeDelete?.length) {
                    locationsList = [...savedLocationListBeforeDelete];
                    const updatedStationsMapIndex = locationsList?.findIndex(favLocation => favLocation?.Location?.Id === locationItemStationChangerData?.location?.Id);
                    if (updatedStationsMapIndex >= 0) {
                        const updatedStationChangerData: LocationItemDetails = { ...locationItemStationChangerData, favoriteLocationIndex: updatedStationsMapIndex };
                        dispatch(toggleStationChanger(updatedStationChangerData));
                    }
                } else {
                    locationsList = [favoriteLocationToUndoDelete];
                }
                dispatch(setupLocationsForPopup(locationsList));
                ngDeps.user.FavoriteLocations = locationsList;
            }

        } catch (error) {
            console.log('Error recreating favorite location with undo action', error);
        } finally {
            await dispatch(clearSavedFavoriteLocationDataForUndo()); // remove saved undo data after undo action is performed
        }
    };
}

export function savePopupLocationDataBeforeDelete(popupDataBeforeDelete: ManageLocationsPopupUndoData): SavePopupLocationDataBeforeDeleteType {
    return {
        type: SAVE_POPUP_LOCATION_DATA_BEFORE_DELETE,
        payload: popupDataBeforeDelete
    };
}

export function reorderLocations(draggableLocationItem: DraggableLocationItem): UserReOrderLocationType {
    const { sourceIndex, destinationIndex, locations } = draggableLocationItem;
    const currentLocationsList = [...locations];
    const [ movedLocationItem ] = currentLocationsList?.splice(sourceIndex, 1);
    currentLocationsList?.splice(destinationIndex, 0, movedLocationItem);

    currentLocationsList?.forEach((location, index) => {
        location.Position = index; // provide new values for Position in the location object
    });

    return {
        type: REORDER_USER_MANAGED_LOCATIONS,
        payload: currentLocationsList
    };
}

export function queryLocationBySlugName(slugName: string): QueryLocationBySlugNameType {
    return {
        type: QUERY_LOCATION_BY_SLUG_NAME.base,
        payload: queryLocationBySlugNameAction(slugName)
    };
}

async function queryLocationBySlugNameAction(slugName: string): Promise<any> {
    const op = new ManageLocationsPopupProvider();
    return await op.queryLocationBySlugName(slugName);
}

export function addSuggestedLocationToFavoriteListAction(selectedLocationIndex: number): void {
    return async (dispatch, getState) => {
        const currState = getState();
        const manageLocationsPopup = currState?.manageLocationsPopup;
        const undoData = manageLocationsPopup?.undoData;
        const locations = manageLocationsPopup?.locations;
        const locationSearchResults = currState?.locationSearch?.locationSearchResults;
        const locationToAdd: Locality = locationSearchResults?.length > 0 && locationSearchResults?.[selectedLocationIndex];

        try {
            if (locationToAdd?.SlugName) {
                const newSearchedLocation = await queryLocationBySlugNameAction(locationToAdd.SlugName);
                const newLocation: Location = {...newSearchedLocation};
                const hasExistingFavorites = locations?.length > 0;
                if (newLocation && newLocation?.Id && newLocation?.Locality) {
                    const newFavoriteLoc: FavoriteLocation = {
                        Id: newLocation?.Id,
                        Location: newLocation,
                        Position: hasExistingFavorites ? locations.length : 0
                    };
                    // ensure we aren't making duplicate favorite locations
                    const isDuplicateFavorite = hasExistingFavorites && locations?.some(existingFavorite => {
                        return (
                            (existingFavorite?.Location?.Locality?.CityId === newFavoriteLoc.Location?.Locality?.CityId ||
                                existingFavorite.Location?.Id === newFavoriteLoc.Location?.Id
                            ) &&
                            existingFavorite?.Location?.DefaultStationRouteString === newFavoriteLoc.Location?.DefaultStationRouteString
                        );
                    });

                    if (!isDuplicateFavorite) {
                        dispatch(createFavoriteLocation(newFavoriteLoc));
                        const updatedFavoriteLocationsList = hasExistingFavorites ? [...locations, newFavoriteLoc] : [newFavoriteLoc];

                        dispatch(setupLocationsForPopup(updatedFavoriteLocationsList));

                        // need to updated saved undo data - avoid reference issues when we update the position in undo data
                        // if user clicks undo, replace favorite list with updated undo list - where we correctly position the last deleted favorite location.
                        if (undoData?.showUndoButton &&
                            undoData?.deletedFavoriteLocation?.Location?.Locality?.SlugName !== newFavoriteLoc?.Location.Locality.SlugName) {
                            const updateNewFavoriteLocationForUndo: FavoriteLocation = cloneDeep(newFavoriteLoc);
                            updateNewFavoriteLocationForUndo.Position = undoData?.favoriteLocationsListBeforeDelete?.length;
                            const updatedUndoFavoriteList = [...undoData?.favoriteLocationsListBeforeDelete, updateNewFavoriteLocationForUndo];
                            dispatch(savePopupLocationDataBeforeDelete({
                                ...undoData,
                                favoriteLocationsListBeforeDelete: updatedUndoFavoriteList
                            }));
                        } else {
                            // new favorite location added is also the data undo - needless keeping this data as this looks like re-enabling the location
                            dispatch(clearSavedFavoriteLocationDataForUndo());
                        }
                        // TODO: remove after all rewrite is done on website
                        // notify angular -
                        ngDeps.user.FavoriteLocations = updatedFavoriteLocationsList;
                    }
                }
            }
        } catch (error) {
            console.log('Error creating new favorite location', error);
        }
    };
}

async function getAllStationsByLatLngAction({lat, lng, radius = 15}: GetAllStationsParams): Station[] | any {
    const op = new ManageLocationsPopupProvider();
    return await op.getAllStationsForLatLng({lat, lng, radius});
}

export function getAllStationsByLatLng({lat, lng, radius = 15}: GetAllStationsParams): GetStationsByLatLngType {
    return {
        type: GET_STATIONS_BY_LAT_LNG.base,
        payload: getAllStationsByLatLngAction({lat, lng, radius})
    };
}

export function toggleStationChanger(stationData?: LocationItemDetails): ToggleStationChangerType {
    return {
        type: TOGGLE_STATION_CHANGER,
        payload: stationData
    };
}

export function locationStationsMapFeatureAction(hoveredItemStationId: string, mapFeatureId: number, isMouseOverItem: boolean): LocationStationMapFeatureHoverActionType {
    const payload: MapFeatureActionPayload = {
        hoveredItemStationId,
        mapFeatureId,
        isMouseOverItem
    };
    return {
        type: MAP_STATION_FEATURE_HOVER_ACTION,
        payload: payload
    };
}

export function stationListItemAction(isListItemHovered: boolean, hoveredListItemStationId: string): StationChangerListItemActionType {
    const payload = {
        hoveredListItemStationId,
        isListItemHovered
    };
    return {
        type: STATION_CHANGER_LIST_ITEM_IS_HOVERED,
        payload: payload
    };
}

export function stationChangerListAction(isStationListHovered: boolean): StationChangerListActionType {
    return {
        type: STATION_LIST_IS_HOVERED,
        payload: isStationListHovered
    };
}

export function onMouseEnterOrLeaveMapIcon(isMouseOverMapIcon: boolean, mapIconStationId?: string): OnMouseEnterOrLeaveMapIconType {
    const payload: MapIconMouseActionPayload = {
        isMouseOverMapIcon,
        stationId: mapIconStationId
    };
    return {
        type: MAP_ICON_HOVERED,
        payload: payload
    };
}

export function onStationSelectAction(selectedLocationId: string, selectedStationIndex: number): void {
    return async (dispatch, getState) => {
        const currState = getState()?.manageLocationsPopup;
        const manageLocationsList: FavoriteLocation[] = currState?.locations;
        const stationsList: Station[] = currState?.toggleStationChanger?.stationsList;
        const selectedLocationIndex: number = currState?.toggleStationChanger?.displayedStationsLocationData?.favoriteLocationIndex;
        const locationToUpdate: Location = currState?.toggleStationChanger?.displayedStationsLocationData?.location;
        const isActiveLocation: boolean = selectedLocationId && locationToUpdate?.Locality.CityId === ngDeps.user.ActiveLocation?.Locality?.CityId &&
            locationToUpdate?.Locality.RouteString === ngDeps.user.ActiveLocation?.Locality.RouteString &&
            locationToUpdate?.Locality?.SlugName === ngDeps.user.ActiveLocation?.Locality.SlugName;
        const newStationData: Station | undefined = selectedStationIndex >= 0 && selectedLocationId ? stationsList?.[selectedStationIndex] : undefined;
        const undoData = currState?.undoData;


        if (locationToUpdate?.Id && selectedLocationId === newStationData?.StationId) {
            locationToUpdate.Station = newStationData;
            let updatedLocation: Location;
            try {
                updatedLocation = await updateLocationOnSelectStation(locationToUpdate);
            } catch (error) {
                // leave everything as is on error but reset stations data/map displayed for location
                dispatch(resetStationChangerDataAction());
            } finally {
                if (updatedLocation?.Id && updatedLocation.Station?.StationId) {
                    if (isActiveLocation) {
                        ngDeps.user.ActiveLocation.Station = updatedLocation?.Station; // update active location
                    }
                    if (undoData?.showUndoButton &&
                        undoData?.deletedFavoriteLocation?.Location?.Locality?.CityId === locationToUpdate?.Locality?.CityId &&
                        undoData?.deletedFavoriteLocation?.Id === locationToUpdate?.Id
                    ) { // don't keep undo data for same location when station changes
                        dispatch(clearSavedFavoriteLocationDataForUndo());
                    }
                    dispatch(resetStationChangerDataAction());

                    // update locations data in popup and user core data
                    if (manageLocationsList?.length && selectedLocationIndex >= 0 && selectedStationIndex >= 0) {
                        // clear/reset all toggle station changer data.
                        manageLocationsList[selectedLocationIndex].Location = updatedLocation;
                        dispatch(setupLocationsForPopup([...manageLocationsList]));
                        ngDeps.user.FavoriteLocations = [...manageLocationsList]; // sync data with core user data
                    }

                    // update undo data -- we may have active location unfavorited, we need to update it's data in undo object as well if it exists in undo list
                    if (undoData?.favoriteLocationsListBeforeDelete?.length && updatedLocation.Station) {
                        const syncUndoDataIndex = undoData?.favoriteLocationsListBeforeDelete?.findIndex(undoItem => {
                            return (
                                undoItem?.Location?.Locality?.CityId === updatedLocation?.Locality.CityId &&
                                undoItem?.Location?.Locality?.SlugName === updatedLocation?.Locality.SlugName
                            );
                        });

                        if (syncUndoDataIndex >= 0) {
                            const updatedUndoData = cloneDeep(undoData);
                            updatedUndoData.favoriteLocationsListBeforeDelete[syncUndoDataIndex].Location.Station = updatedLocation.Station;
                            dispatch(savePopupLocationDataBeforeDelete(updatedUndoData));
                        }
                    }
                }
            }
        }
    };
}

async function updateLocationOnSelectStation(location: Location) {
    const op = new ManageLocationsPopupProvider();
    return await op.updateLocationStationData(location);
}

export function resetStationChangerDataAction(): ResetStationChangerDataActionType {
    return {
        type: RESET_STATION_CHANGER_DATA
    };
}

export function isInitialStationsChangerLoad(isInitialMount: boolean): IsInitialStationsChangerLoadActionType {
    return {
        type: IS_INITIAL_STATIONS_CHANGER_LOAD,
        payload: isInitialMount
    };
}